// extracted by mini-css-extract-plugin
export default {"box":"AnnouncementInfoModal_box__hWueH"};